import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { r as renderInputValidationMessage } from '../../InputFormGroup/InputFormGroup-gvfAL3o3.js';
import { T as TileGroupContextProvider } from '../TileGroupContext-CvSfRsxH.js';
import { F as Fieldset, C as Container, M as MessageWrapper } from './TileGroup.styles-B3Sj97Fa.js';
import { a as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

function TileGroup({
  children,
  numColumns,
  direction,
  disabled,
  message,
  statusType,
  id,
  multiple,
  name,
  onChange,
  selectedValues,
  taktId,
  taktValue,
  ...restProps
}) {
  const messageId = `${name}-${id}-tile-group-message`;
  const a11yProps = message ? {
    'aria-describedby': messageId,
    ...(statusType === 'error' ? {
      'aria-invalid': true
    } : {})
  } : {};
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('tile-group')
  }, /*#__PURE__*/React__default.createElement(TileGroupContextProvider, {
    direction: direction !== null && direction !== void 0 ? direction : 'column',
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    multiple: multiple !== null && multiple !== void 0 ? multiple : false,
    name: name,
    onSelect: (value, event) => {
      if (onChange) {
        let values = [value];
        if (multiple) {
          const prevSelectedValues = [...(selectedValues !== null && selectedValues !== void 0 ? selectedValues : [])];
          const index = prevSelectedValues.indexOf(value);
          if (index !== -1) {
            values = [...prevSelectedValues.slice(0, index), ...prevSelectedValues.slice(index + 1)];
          } else {
            values = [...prevSelectedValues, value];
          }
        }
        onChange(values, event);
      }
    },
    selectedValues: selectedValues !== null && selectedValues !== void 0 ? selectedValues : []
  }, /*#__PURE__*/React__default.createElement(Fieldset, _extends({}, a11yProps, restProps, {
    disabled: disabled,
    id: id
  }), /*#__PURE__*/React__default.createElement(Container, {
    $numColumns: numColumns
  }, children), message && /*#__PURE__*/React__default.createElement(MessageWrapper, null, renderInputValidationMessage(undefined, messageId, message, undefined, statusType)))));
}
TileGroup.defaultProps = {
  numColumns: undefined,
  direction: undefined,
  disabled: false,
  message: undefined,
  statusType: 'error',
  id: undefined,
  multiple: false,
  onChange: undefined,
  selectedValues: []
};
TileGroup.propTypes = {
  /**
   * Content of the TileGroup (Tiles).
   */
  children: PT.node.isRequired,
  /**
   * The name of the TileGroup. This MUST be unique, and it allows the group to manage all children properly.
   */
  name: PT.string.isRequired,
  /**
   * Set this to have a fixed number of columns.
   */
  numColumns: PT.number,
  /**
   * How Tile's header, body and footer are placed.
   */
  direction: PT.oneOf(['column', 'row']),
  /**
   * Set this to true to indicate the Tiles are disabled.
   */
  disabled: PT.bool,
  /**
   * Adds a message below the input, which will update based on error/success/warning.
   */
  message: PT.string,
  /**
   * Specifies the type of message to be displayed. Can be 'error', 'warning', 'success'. (Default is 'error')
   */
  statusType: PT.oneOf(['error', 'warning', 'success']),
  /**
   * The page unique identifier of the input.
   */
  id: PT.string,
  /**
   * Set this to true to indicate that the user can select multiple Tiles.
   */
  multiple: PT.bool,
  /**
   * Called when the user changes the selected values.
   */
  onChange: PT.func,
  /**
   * Values selected by the user.
   */
  selectedValues: PT.arrayOf(PT.oneOfType([PT.string, PT.number]))
};

export { TileGroup as T };
//# sourceMappingURL=TileGroup--CDbVOFe.js.map
